export const UNKNOWN = Symbol();
export const OAUTH_REDIRECT = Symbol();
export const INTERNAL_AUTHENTICATION = Symbol();
export const EXTERNAL = Symbol();
